import _classCallCheck from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// Copyright 2017-2021 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { Int } from "../codec/Int.mjs";
/**
 * @name i128
 * @description
 * A 128-bit signed integer
 */

export var i128 =
/*#__PURE__*/
function (_Int$with) {
  _inherits(i128, _Int$with);

  function i128() {
    _classCallCheck(this, i128);

    return _possibleConstructorReturn(this, _getPrototypeOf(i128).apply(this, arguments));
  }

  return i128;
}(Int.with(128));